import React from 'react';
import { Link } from 'react-router-dom';
import ImageComponent from '../Image/ImageComponent';
import { applyDiscount } from '../../../utils/discountUtils';
import { useUserDiscountEligibility } from '../../../hooks/useUserDiscountEligibility';
import './ProductCard.css';

const ProductCard = ({ product, square=false, onNavigate }) => {
  // Handle differences between API and mock data structures
  const productId = product._id || product.id;
  const { name, price, mainImage } = product;
  const isOutOfStock = product.availableQuantity === 0;
  const isPreorderAvailable = isOutOfStock && product.isPreorderAvailable;

  const { isFriendsAndFamily, isRoyalSubscriber, getDiscountPct } = useUserDiscountEligibility();
  const discountPct = getDiscountPct(product);
  const discountedPrice = discountPct > 0 ? applyDiscount(price, discountPct) : null;

  const e = product?.discountEligibility || {};
  let discountBadge = null;
  if (e.sales) {
    discountBadge = { label: 'SALE', type: 'sale' };
  } else if (e.friendsAndFamily && isFriendsAndFamily) {
    discountBadge = { label: 'F&F', type: 'friends' };
  } else if (e.subscribers && isRoyalSubscriber) {
    discountBadge = { label: 'MEMBERS', type: 'members' };
  }

  return (
    <Link
      to={`/product/${productId}`}
      onClick={() => {
        onNavigate?.();
        window.scrollTo(0, 0);
      }}
      className="product-card-link"
    >
      <div className={`product-card-image-wrapper ${square ? 'square' : ''}`}>
        <ImageComponent
          src={mainImage}
          alt={name}
          className="product-card-img"
        />
        {isPreorderAvailable && (
          <span className="product-card-badge product-card-badge--preorder">PRE-ORDER</span>
        )}
        {isOutOfStock && !isPreorderAvailable && (
          <span className="product-card-badge product-card-badge--out-of-stock">OUT OF STOCK</span>
        )}
        {discountBadge && (
          <span className={`product-card-badge product-card-badge--discount product-card-badge--${discountBadge.type}`}>
            {discountBadge.label}
          </span>
        )}
      </div>

      <div className="product-card-details">
        <h3 className="product-card-name">{name}</h3>
        <p className="product-card-price">
          {discountedPrice ? (
            <>
              <span className="product-card-price--original">£{typeof price === 'number' ? price.toFixed(2) : price}</span>
              <span className="product-card-price--sale">£{discountedPrice.toFixed(2)}</span>
            </>
          ) : (
            <>£{typeof price === 'number' ? price.toFixed(2) : price}</>
          )}
        </p>
      </div>
    </Link>
  );
};

export default ProductCard;